import { CREATE_PROFILE } from "../ActionTypes/authenticationActionTypes";

export const createProfileRequest=(response)=>({
    type:CREATE_PROFILE,
    payload:response
})